/**
 * Region y comuna como dos selectores encadenados (CHK-03, CHK-04).
 *
 * Nunca texto libre: la comuna decide la tarifa del despacho (ADM-10) y el
 * `KOCM` que se le manda a Random, y una comuna escrita a mano —con o sin
 * tilde, bien o mal— no calza con ninguno de los dos.
 *
 * Lo usan la direccion de despacho (solo las regiones a las que se despacha) y
 * la de facturacion (las 16): cada uno pasa su lista.
 */
import { Campo } from './Campo';

interface RegionOpcion {
  codigo: string;
  nombre: string;
}

interface Props {
  /** `ck` da `ck-region` y `ck-comuna`. */
  prefijoId: string;
  /** Para el autocompletado del navegador: despacho o facturacion. */
  seccion: 'shipping' | 'billing';
  regiones: readonly RegionOpcion[];
  /** Las comunas de la region elegida; `undefined` mientras no haya region. */
  comunas: readonly string[] | undefined;
  codigoRegion: string;
  comuna: string;
  errorRegion: string | undefined;
  errorComuna: string | undefined;
  alCambiarRegion: (codigo: string) => void;
  alCambiarComuna: (comuna: string) => void;
  alSalirRegion: () => void;
  alSalirComuna: () => void;
}

export function SelectorRegionComuna({
  prefijoId,
  seccion,
  regiones,
  comunas,
  codigoRegion,
  comuna,
  errorRegion,
  errorComuna,
  alCambiarRegion,
  alCambiarComuna,
  alSalirRegion,
  alSalirComuna,
}: Props) {
  return (
    <div className="fila-campos">
      <Campo id={`${prefijoId}-region`} etiqueta="Región" error={errorRegion}>
        {(atributos) => (
          <select
            {...atributos}
            autoComplete={`${seccion} address-level1`}
            value={codigoRegion}
            onChange={(evento) => alCambiarRegion(evento.target.value)}
            onBlur={alSalirRegion}
          >
            <option value="">Elige la región</option>
            {regiones.map((region) => (
              <option key={region.codigo} value={region.codigo}>
                {region.nombre}
              </option>
            ))}
          </select>
        )}
      </Campo>

      <Campo id={`${prefijoId}-comuna`} etiqueta="Comuna" error={errorComuna}>
        {(atributos) => (
          <select
            {...atributos}
            autoComplete={`${seccion} address-level2`}
            disabled={comunas === undefined}
            value={comuna}
            onChange={(evento) => alCambiarComuna(evento.target.value)}
            onBlur={alSalirComuna}
          >
            <option value="">
              {comunas === undefined ? 'Elige primero la región' : 'Elige la comuna'}
            </option>
            {(comunas ?? []).map((nombre) => (
              <option key={nombre} value={nombre}>
                {nombre}
              </option>
            ))}
          </select>
        )}
      </Campo>
    </div>
  );
}
